import DescriptionTwoToneIcon from "@material-ui/icons/DescriptionTwoTone";
import PeopleOutlineTwoToneIcon from "@material-ui/icons/PeopleOutlineTwoTone";
import ListAltTwoToneIcon from "@material-ui/icons/ListAltTwoTone";
import PeopleAltTwoToneIcon from "@material-ui/icons/PeopleAltTwoTone";

export default function navConfig() {
  return [
    {
      subheader: "Presupuestos",
      items: [
        {
          title: "Ver Presupuestos",
          icon: ListAltTwoToneIcon,
          href: "/lista-presupuesto",
        },
      ],
    },
  ];
}
